// extracted by mini-css-extract-plugin
module.exports = {"approval":"approval_approval__oIGuy","approval_text":"approval_approval_text__pPggq","approval_list":"approval_approval_list__Cm6BN"};